import React, {useState} from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {observer} from 'mobx-react'
import {formatNumber, string} from '../../../helper/common'
import ConfirmButton from '../button/confirm_button'
import {rootStore} from '../../../mobx/store'

const ItemBuyModal = observer((props) => {
  const {show, toggle, item, couponList, onConfirm} = props
  let [selectedCoupon, setSelectedCoupon] = useState(0)
  let [couponVal, setCouponVal] = useState(0)

  const onConfirmBuy = () => {
    const coupon = selectedCoupon === 0 ? null : couponList[selectedCoupon - 1]
    onConfirm(item.it_price - couponVal, coupon)
  }

  const selectCoupon = (idx) => {
    setSelectedCoupon(idx)
    if (idx === 0) {
      setCouponVal(0)
    } else {
      const coupon = couponList[idx - 1]
      setCouponVal(coupon.cp_price)
    }
  }

  return (
    <Modal isOpen={show} toggle={() => toggle()} className='modal-point-pay'>
      <ModalBody>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{strings.item_buy}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-po-lack text-center'>
          <div className='fs-16 sm-fs-14 f-b text-left'>{string.Format(strings.confirm_buy_item, item.it_name)}</div>
          <div className='d-flex align-items-center mt-20'>
            <div className='fs-16 sm-fs-14 f-m color-808080'>{strings.cur_point}</div>
            <div className='fs-16 sm-fs-14 f-m color-808080 ml-20'>{formatNumber(rootStore.getMe?.mb_point ?? 0) + strings._p}</div>
          </div>
          <div className='fs-14 mt-20 f-b text-left'>{strings.point_spend}</div>
          <div className='item-point-input-area fs-15 mt-5 ph-15 d-flex align-items-center'>{formatNumber(item.it_price - couponVal)}</div>
          <div className='fs-14 mt-20 f-b text-left'>{strings.coupon_use}</div>
          <select className='form-control coupon_select mt-5' value={selectedCoupon} onChange={(e) => {selectCoupon(parseInt(e.target.value))}}>
            <option value={0}>{strings.coupon_select}</option>
            {couponList.map((it, idx) => {return (<option value={idx + 1} key={idx}>{it.cp_name}</option>)})}
          </select>
          <div className='mt-30 point-info'>
            <div className='d-flex align-items-center'>
              <div className='fs-16 sm-fs-14 f-m color-4c4c4d'>{strings.buy_point}</div>
              <div className='fs-18 sm-fs-16 color-0f4c81 f-sb ml-20'>{formatNumber(item.it_price) + strings._p}</div>
            </div>
          </div>
          <div className='d-center mt-60 sm-mt-20'>
            <ConfirmButton enabled={true} className={'bd-0 btn-primary fs-15 sm-fs-14 f-m d-center'} onClick={onConfirmBuy} text={strings.buying} />
            <ConfirmButton enabled={true} className={'btn-grey-border fs-15 sm-fs-14 f-m d-center ml-10'} onClick={toggle} text={strings.close} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default ItemBuyModal
